export default __webpack_public_path__ + "ba65f0e66fd4926009d935626116142f.png";